'use strict';

import { createElement } from "react";
import ReactDOM from "react-dom";
import Typeahead from 'components/input/Typeahead';
import InterNACHI from "shared/InterNACHI";
import createBladeComponentCallbacks from 'shared/createBladeComponentCallbacks.js';

InterNACHI.helpers.bootTypeahead = (id, props, callbacks) => {
	const element = document.getElementById(id);
	
	window.createReactElement = createElement;
	
	createBladeComponentCallbacks(element, callbacks)
		.map(([event, callback]) => {
			props[event] = callback;
		});
	
	InterNACHI.shared.typeaheadCallbacks = InterNACHI.shared.typeaheadCallbacks || {};
	
	ReactDOM.render(
		<Typeahead id={ id } { ...props } />,
		element
	);
};
